import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MessageContext } from "../context/MessageContext";

function Register() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [errors, setErrors] = useState("");

  const { showMessage } = useContext(MessageContext);
  const validate = () => {
    let newErrors = {};

    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    if (!password) newErrors.password = "Password is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const API_URL = process.env.REACT_APP_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    // setError("");
    if (!validate()) {
      return;
    }


    try {
      const res = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, password }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        showMessage(data.message, "danger");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      showMessage(data.message, "success");
      navigate("/");

    } catch (err) {
      setError(err.message);
      showMessage(err.message, "danger");
    }
  };

  return (
    <>
      <div style={{ marginBottom: '50px' }}></div>
      <div className="page-title">
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><NavLink to="/">Home</NavLink></li>
              <li className="current">Register</li>
            </ol>
          </div>
        </nav>
      </div>
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-5 col-md-7">
              <div className="card shadow-sm">
                <div className="card-body p-4">

                  <h4 className="text-center mb-4">
                    <i className="bi bi-person-circle me-2"></i>
                    Register Account
                  </h4>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)}

                      />
                      {errors.name && <small className="text-danger">{errors.name}</small>}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)}

                      />
                      {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)}

                      />
                      {errors.password && <small className="text-danger">{errors.password}</small>}
                    </div>

                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">
                        Register
                      </button>
                    </div>
                  </form>

                  <div className="text-center mt-4">
                    <span className="small">
                      If you have an account?
                    </span>{" "}
                    <NavLink to="/login" className="fw-semibold">
                      Login
                    </NavLink>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Register;
